export default function RoleViewDeleteModalController(
  $scope,
  $uibModalInstance,
  roleName,
  roleId,
  $state,
  usersService,
  gettextCatalog,
) {
  'ngInject';

  $scope.roleName = roleName;

  $scope.ok = function () {
    usersService.deleteRoleDetails(roleId).then(
      function (response) {
        $state.go('admin.usersRoleslist', { create: false, deleted: true });
      },
      function (error) {
        var errorMsg;
        if (error.status === 409 && error.data.Message.indexOf('role_in_use') === 0) {
          errorMsg = gettextCatalog.getString(
            'This role is currently in use, all users must be removed from a role before it can be deleted. If the problem persists please contact your admin!',
          );
        } else {
          errorMsg = gettextCatalog.getString(
            'An error occurred while deleting role information',
          );
          if (error.data || error.status) {
            if (error.data.Message) {
              errorMsg =
                error.data.Message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
      },
    );
  };

  $scope.cancel = function () {
    $uibModalInstance.close('cancel');
  };

  $scope.$on('$locationChangeStart', function (event, next, current) {
    $scope.cancel();
  });
}
